// extracted by mini-css-extract-plugin
export default {"container":"ProgramFormDuplicate_container__tUkkR","card":"ProgramFormDuplicate_card__3gogw","title":"ProgramFormDuplicate_title__YxCeK"};